import fetchBotStatus from './fetchBotStatus';

// Verbose logging flag
const verboseChatbot = import.meta.env.VITE_APP_VERBOSE === 'true';

export const getBotStatus = (chatbotStatusIsOnline, recommenderStatusIsOnline) => {
  const chatbotUrl = '/api/v1/bot-status/status';
  const recommenderUrl = '/api/v1/bot-status/recommender';

  // Fetch chatbot status with error handling
  fetchBotStatus(chatbotUrl)
    .then(response => {
      chatbotStatusIsOnline.value = response;
      if (verboseChatbot) {
        console.log('Chatbot status:', response);
      }
    })
    .catch(error => {
      console.error('Error fetching chatbot status:', error);
      chatbotStatusIsOnline.value = false; // Default to offline
    });

  // Fetch recommender status with error handling
  fetchBotStatus(recommenderUrl)
    .then(response => {
      recommenderStatusIsOnline.value = response;
      if (verboseChatbot) {
        console.log('Recommender status:', response);
      }
    })
    .catch(error => {
      console.error('Error fetching recommender status:', error);
      recommenderStatusIsOnline.value = false; // Default to offline
    });
}
